Ext.define('SA.view.quickreport.drag.QuickReportDragHandler', {
    alias: 'quickreport.drag-handler',

    constructor() {
        this.processDrag = this.processDrag.bind(this);
    },

    getFloatingColumnLeftForCurrentPageX() {
        return this.delegate.pageXToLeft(this.pageX);
    },

    invokeDelegateCallback() {
        var delegate = this.delegate;

        if (this.didDrag) {
            delegate.onDragEnd();
        }
        else {
            delegate.onClick();
        }
    },

    maybeScroll() {
        var floatingColumn = this.floatingColumn,
            left = getScrollDistance(floatingColumn.distanceObscuredAtRight()),
            right = getScrollDistance(floatingColumn.distanceObscuredAtLeft()),
            delta = left - right;

        if (delta === 0) {
            return;
        }

        this.delegate.scrollLeftBy(delta);

        function getScrollDistance(distance) {
            return Math.min(20, Math.ceil(distance / 3));
        }
    },

    onMouseDown(delegate, pageX, visibleXBounds, columnEls) {
        var me = this,
            doc = Ext.getDoc();

        this.didDrag = false;
        this.delegate = delegate;

        this.setPageX(pageX);

        this.floatingColumn = createFloatingColumn();
        this.swappableColumn = Ext.createByAlias('quickreport.swappable-column', columnEls);
        this.dragMask = Ext.DomHelper.append(Ext.getBody(), {cls: 'sa-quick-report-drag-mask'}, true);

        doc.on('mousemove', this.onMouseMoveInitial, this, {single: true});
        doc.on('mouseup', this.onMouseUp, this, {single: true});

        function createFloatingColumn() {
            var initialLeft = me.getFloatingColumnLeftForCurrentPageX();

            return Ext.createByAlias('quickreport.floating-column', columnEls, initialLeft, visibleXBounds);
        }
    },

    onMouseMoveInitial(ev) {
        this.didDrag = true;

        this.setPageX(ev.getPageX());

        this.swappableColumn.setDragging(true);

        this.processDrag();

        Ext.getDoc().on('mousemove', this.onMouseMoveNonInitial, this);
    },

    onMouseMoveNonInitial(ev) {
        this.setPageX(ev.getPageX());
    },

    onMouseUp() {
        var doc = Ext.getDoc();

        clearTimeout(this.processDragRequest);

        this.invokeDelegateCallback();

        this.swappableColumn.setDragging(false);

        this.delegate = null;

        doc.un('mousemove', this.onMouseMoveInitial, this);
        doc.un('mousemove', this.onMouseMoveNonInitial, this);

        Ext.destroyMembers(this, 'dragMask', 'floatingColumn', 'swappableColumn');
    },

    processDrag() {
        var left = this.getFloatingColumnLeftForCurrentPageX(),
            swapBuffer = 3;

        this.floatingColumn.setLeft(left);
        this.swappableColumn.maybeSwapWithSibling(left, swapBuffer);
        this.maybeScroll();

        this.processDragRequest = setTimeout(this.processDrag, 16);
    },

    setPageX(pageX) {
        this.pageX = pageX;
    }
});